import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

interface StyledImagePreviewBoxProps {
  smScreen?: boolean;
}

export const StyledImagePreviewBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'smScreen',
})<StyledImagePreviewBoxProps>(({ smScreen = false }) => ({
  width: 100,
  height: 100,
  borderRadius: '50%',
  border: '2px solid var(--border)',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'var(--text-bg)',
  boxShadow: smScreen ? 'none' : '0px 0px 10px rgba(0,0,0,0.1)',
  marginBottom: '8px',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

interface StyledUploadButtonProps {
  buttonWidth?: string;
}

export const StyledUploadButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'buttonWidth',
})<StyledUploadButtonProps>(({ buttonWidth = '150px' }) => ({
  marginTop: '16px',
  marginBottom: '16px',
  width: buttonWidth,
  height: '45px',
  fontFamily: 'Outfit',
  fontSize: '16px',
  fontWeight: '500',
  textAlign: 'left',
}));

export const StyledNoImageText = {
  fontFamily: 'Outfit',
  fontWeight: '400',
  fontSize: '16px',
  color: 'var(--primary-navy)',
  textAlign: 'center' as const,
};
